<template>
  <div>
    <section class="davich-number-edit">
      <div class="section-inner">
        <div class="section-cont">
          <h2>숫자로 보는 다비치 관리</h2>
          <p class="site-path">
            <span>Home</span>&nbsp;&gt;&nbsp;
            <span>OTHERS</span>&nbsp;&gt;&nbsp;
            <span>숫자로 보는 다비치 관리</span>
          </p>

          <table>
            <colgroup>
              <col class="col1" />
              <col class="col2" />
              <col class="col3" />
              <col class="col4" />
              <col class="col5" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">가맹점수</th>
                <th scope="col">사관·공채졸업생</th>
                <th scope="col">안경기부 데이터 관리</th>
                <th scope="col">고객 수</th>
                <th scope="col">봉사활동(사회공헌)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="num-field">
                    <input
                      type="text"
                      inputmode="numeric"
                      name=""
                      id=""
                      :value="formatNumber(franchise_count)"
                      @input="onNumberInput($event, 'SET_FRANCHISE_COUNT', 'franchise_count')"
                      @compositionend="onNumberInput($event, 'SET_FRANCHISE_COUNT', 'franchise_count')"
                    />
                    <span class="unit">개</span>
                  </div>
                </td>
                <td>
                  <div class="num-field">
                    <input
                      type="text"
                      inputmode="numeric"
                      name=""
                      id=""
                      :value="formatNumber(graduate_count)"
                      @input="onNumberInput($event, 'SET_GRADUATE_COUNT', 'graduate_count')"
                      @compositionend="onNumberInput($event, 'SET_GRADUATE_COUNT', 'graduate_count')"
                    />
                    <span class="unit">명</span>
                  </div>
                </td>
                <td>
                  <div class="num-field">
                    <input
                      type="text"
                      inputmode="numeric"
                      name=""
                      id=""
                      :value="formatNumber(glasses_give_count)"
                      @input="onNumberInput($event, 'SET_GLASSES_COUNT', 'glasses_give_count')"
                      @compositionend="onNumberInput($event, 'SET_GLASSES_COUNT', 'glasses_give_count')"
                    />
                    <span class="unit">개</span>
                  </div>
                </td>
                <td>
                  <div class="num-field">
                    <input
                      type="text"
                      inputmode="numeric"
                      name=""
                      id=""
                      :value="formatNumber(customer_count)"
                      @input="onNumberInput($event, 'SET_CUSTOMER_COUNT', 'customer_count')"
                      @compositionend="onNumberInput($event, 'SET_CUSTOMER_COUNT', 'customer_count')"
                    />
                    <span class="unit">만</span>
                  </div>
                </td>
                <td>
                  <div class="num-field">
                    <input
                      type="text"
                      inputmode="numeric"
                      name=""
                      id=""
                      :value="formatNumber(volunteer_count)"
                      @input="onNumberInput($event, 'SET_VOLUNTEER_COUNT', 'volunteer_count')"
                      @compositionend="onNumberInput($event, 'SET_VOLUNTEER_COUNT', 'volunteer_count')"
                    />
                    <span class="unit">회</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <a class="btn-blue btn-right" @click="onSubmitModify">수정</a>
        </div>
        <app-footer />
      </div>
    </section>
  </div>
</template>

<script>
import AppFooter from "../../AppFooter.vue";

// 입력 가능한 최대 자릿수 ( DB INT 최대값 2,147,483,647 미만 )
const MAX_DIGITS = 10;

export default {
  components: { AppFooter },
  name: "DavichNumberEdit",
  data() {
    return {};
  },
  computed: {
    franchise_count() {
      return this.$store.state.others.franchise_count;
    },
    graduate_count() {
      return this.$store.state.others.graduate_count;
    },
    glasses_give_count() {
      return this.$store.state.others.glasses_give_count;
    },
    customer_count() {
      return this.$store.state.others.customer_count;
    },
    volunteer_count() {
      return this.$store.state.others.volunteer_count;
    },
  },
  created() {
    this.$store.dispatch("others/getDavichNumbers");
  },
  methods: {
    // 숫자 천단위 콤마
    formatNumber(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      return String(value)
        .replace(/[^0-9]/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 숫자만 입력되도록 거르고 콤마를 다시 찍는다. ( store 에는 콤마 없는 숫자로 저장 )
    onNumberInput(event, mutation, key) {
      const el = event.target;
      const raw = el.value;
      // 커서 앞에 있던 숫자 개수 ( 콤마를 다시 찍은 뒤 커서 위치를 되돌리기 위함 )
      const caret = el.selectionStart == null ? raw.length : el.selectionStart;
      let digitsBeforeCaret = raw.slice(0, caret).replace(/[^0-9]/g, "").length;

      // 숫자만 남기고 앞자리 0 제거, DB 컬럼(INT) 범위를 넘지 않도록 9자리까지
      let digits = raw.replace(/[^0-9]/g, "").replace(/^0+(?=\d)/, "");
      if (digits.length > MAX_DIGITS) {
        // 자릿수를 넘기면 이번 입력은 무시하고 이전 값으로 되돌린다.
        const prev = this.formatNumber(this[key]).replace(/,/g, "");
        digitsBeforeCaret -= digits.length - prev.length;
        digits = prev;
      }
      digitsBeforeCaret = Math.max(0, Math.min(digitsBeforeCaret, digits.length));

      this.$store.commit(`others/${mutation}`, {
        [key]: digits === "" ? "" : Number(digits),
      });

      // 문자 입력처럼 store 값이 그대로여도 화면 값은 다시 맞춰 준다.
      const formatted = this.formatNumber(digits);
      el.value = formatted;

      let pos = 0;
      let count = 0;
      while (pos < formatted.length && count < digitsBeforeCaret) {
        if (formatted[pos] !== ",") {
          count++;
        }
        pos++;
      }
      if (document.activeElement === el) {
        el.setSelectionRange(pos, pos);
      }
    },
    onSubmitModify() {
      console.log("onSubmitModify : ", this.volunteer_count);
      const values = [
        this.franchise_count,
        this.graduate_count,
        this.glasses_give_count,
        this.customer_count,
        this.volunteer_count,
      ];
      if (values.some((v) => v === "" || v === null || v === undefined)) {
        this.$alert("값을 모두 입력해 주세요.").then(() => {});
        return;
      }
      this.$store
        .dispatch("others/updateDavichNumbers", {
          franchise_count: this.franchise_count,
          graduate_count: this.graduate_count,
          glasses_give_count: this.glasses_give_count,
          customer_count: this.customer_count,
          volunteer_count: this.volunteer_count,
        })
        .then((res) => {
          this.$store.commit("others/SET_DAVICH_NUMBERS", res.data);
          this.$alert("수정하였습니다.").then(() => {});
        })
        .catch((error) => {
          console.log("error => ", error);
          // 로그인 만료(401)는 axios-auth 인터셉터에서 안내 후 로그인 페이지로 이동한다.
          if (error && error.isAuthError) {
            return;
          }
          // $alert 의 두 번째 인자는 title 이므로 error 객체를 넘기면 sweetalert 에서 오류가 난다.
          this.$alert("수정에 실패하였습니다.").then(() => {});
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.davich-number-edit {
  // 단위 글자 폭 + 간격 ( input 이 칸 가운데 오도록 왼쪽에 같은 폭을 비워 둔다 )
  $unit-width: 16px;
  $unit-gap: 10px;

  table {
    table-layout: fixed;
    colgroup {
      .col1,
      .col2,
      .col3,
      .col4,
      .col5 {
        width: 20%;
      }
    }
  }
  td {
    padding: 28px 15px;
    text-align: center;
    vertical-align: middle;
  }
  .num-field {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: $unit-width + $unit-gap;
    input {
      flex: 0 1 180px;
      min-width: 0;
      height: 50px;
      border: 1px solid #ccc;
      text-align: center;
    }
    .unit {
      flex: 0 0 $unit-width;
      margin-left: $unit-gap;
      text-align: left;
    }
  }
}
</style>
